import { render, staticRenderFns } from "./PacksPage.vue?vue&type=template&id=6a93b7a6&scoped=true&lang=pug&"
import script from "./PacksPage.vue?vue&type=script&lang=js&"
export * from "./PacksPage.vue?vue&type=script&lang=js&"
import style0 from "./PacksPage.vue?vue&type=style&index=0&id=6a93b7a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a93b7a6",
  null
  
)

export default component.exports